import { LoginService } from 'src/app/components/Shared/Service/login_service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr'

import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource } from '@angular/material';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-strlog',
  templateUrl: './strlog.component.html',
  styleUrls: ['./strlog.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class StrlogComponent implements OnInit {
  pageSize = 50;
  pageSizeOptions: number[]
  storeUserID: any
  apiresult: any;
  statusResult: string;
  requestPayload: any;
  storeOptionData = "Report";
  errorMsgSubscription: boolean;
  displayContent: boolean;
  errorMessage: string;
  public idsProductList: idsProductList[];
  dataSource: MatTableDataSource<idsProductList>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  selectedReProcessStoreToDate: any;
  selectedReProcessStoreFromDate: any;
  selectedStoreDate: any;
  selectedStoreTOODate: any;
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe, public loginService: LoginService) {

  }
  selected: string;
  User: string;
  Userid: any = [];
  public status: string;
  public header: string;
  property: string;
  SourceBy: string;
  today1: any = new Date();
  today: any = new Date();
  today3: any = new Date();
  today4: any = new Date();

  lastThirthydays: any = new Date(this.today.setDate(this.today.getDate() - 30));
  afterThirthydays: any = new Date(this.today.setDate(this.today.getDate() + 30));
  
  selectedDate: any = new Date(this.today.setDate(this.today.getDate() - 1));
  selectedTOODate: any = new Date(this.today1.setDate(this.today1.getDate() - 1));
  selectedReProcessFromDate: any = new Date(this.today3.setDate(this.today3.getDate() - 1));
  selectedReProcessToDate: any = new Date(this.today4.setDate(this.today4.getDate() - 1));
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  public Val: any;
  displayedColumns: string[] = ['Status', 'Hotel', 'tichotelcode','heartbeat', 'Accounting date','Created Date', 'File name 1', 'File name 2', 'Processed Date', 'Sent to STR'];
  
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems:any;
  dropdownDeptData: any
  checkTodayDate:any
  CurrentDate = new Date();
  ngOnInit() {
    this.checkTodayDate = this.CurrentDate.getDate()
    console.log('check Today =', this.checkTodayDate)
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.callIDSUsersProperties();
    this.SourceBy = "Report";
    this.statusResult = "Not Sent"
    this.dropdownSettingsDept = {
      idField: 'propertyCode',
      textField: 'propertyName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  callIDSUsersProperties() {
    this.storeUserID = localStorage.getItem("Username");
    console.log('this.storeUserID', this.storeUserID)
    this.apiCallIdsService.getSTRProperties()
      .subscribe(
        data => {
          console.log('New Screen Data', data)

          this.apiresult = data;
          console.log('this.SourceBy =', this.SourceBy)
          if (this.SourceBy == 'Report') {
            this.apiresult.unshift({
              "propertyCode": "All",
              "propertyName": "All Property"
            });
          }

          this.dropdownDeptData = this.apiresult
          if (this.SourceBy == 'Report') {
        this.selectedDeptItems = this.getDimensionsByFilter("All");
        console.log('this.StoreValuetest',this.selectedDeptItems[0].propertyCode);
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('this.Pmscodevalue =',this.Pmscodevalue)
          }
          this.isProgressing = false;
        });
  }

  // GetParseonlyDateTimeHeartbeat(d:any) {
  //   console.log('GetParseonlyDateTimeHeartbeat',d)
  //   if (d == "") {
  //     return "";
  //   }
  //   console.log('GetParseonlyDateTimeHeartbeat = ',d.substring(0, 2))
  //   return (d.substring(0, 2));
  // }

  GetParseonlyDateTimeHeartbeat(d:any) {
    var dt1 = new Date(d);
    var dt2 = new Date();
    // console.log('dt1 = ',dt1)
    // console.log('dt2 = ',dt2)
    var diff =(dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    // console.log('Math ABS = ',Math.abs(Math.round(diff)));
    if(Math.abs(Math.round(diff)) > 60){
      return false
    }else{
      return true
    }
      }

  getDimensionsByFilter(propertyCode:any){
    console.log('dropdownDeptData =',this.dropdownDeptData)
    return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }


  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('pms code value = ', this.Pmscodevalue)

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  changeOption(data: any) {
    console.log("changeOption Value--->" + data);
    this.storeOptionData = data
    if (data == 'RE-Process') {
      this.statusResult = "All"
      this.SourceBy = data
      this.selectedDeptItems = ""
      this.callIDSUsersProperties();
    } else {
      this.statusResult = "Not Sent"
      this.SourceBy = data
      this.selectedDeptItems = ""
      this.callIDSUsersProperties();
    }
  }

  GetBTEALOGNew() {
    this.isProgressing = true;
    if(this.selectedTOODate < this.selectedDate || this.selectedReProcessStoreToDate < this.selectedReProcessStoreFromDate){
    this.isProgressing = false;
    this.toastr.error('From date shuold be less than To date.');
    }else if(this.SourceBy == 'Report'){
      console.log('Report')
      this.selectedStoreDate = this.datePipe.transform(this.selectedDate, 'yyyyMMdd');
    this.selectedStoreTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyyMMdd');
      this.requestPayload = {
        "PMSCODE": this.Pmscodevalue,
        "FROMDATE": this.selectedStoreDate,
        "TODATE": this.selectedStoreTOODate,
        "STATUS": this.statusResult,
        "OPTION": this.SourceBy
        // "USERID": this.storeUserID,
      }   
  
      console.log('Request =', this.requestPayload)
      this.readAPICalling();
    }
    else if(this.SourceBy == 'RE-Process'){
      console.log('RE- Process entry')
      this.selectedReProcessStoreFromDate = this.datePipe.transform(this.selectedReProcessFromDate, 'yyyyMMdd');
    this.selectedReProcessStoreToDate = this.datePipe.transform(this.selectedReProcessToDate, 'yyyyMMdd');
      this.requestPayload = {
        "PMSCODE": this.Pmscodevalue,
        "FROMDATE": this.selectedReProcessStoreFromDate,
        "TODATE": this.selectedReProcessStoreToDate,
        "STATUS": this.statusResult,
        "OPTION": this.SourceBy
        // "USERID": this.storeUserID,
      }
      console.log('Request =', this.requestPayload)
      this.readAPICalling();
    }
    
  }

  readAPICalling(){
    this.apiCallIdsService.readSTRPropertiesData(this.requestPayload)
    .subscribe(
      data => {
        console.log('Data =', data)
        this.idsProductList = data;
        this.dataSource = new MatTableDataSource(this.idsProductList);
        this.dataSource.paginator = this.paginator;
        console.log('storeOptionData =', this.storeOptionData)
        if (this.storeOptionData == 'Report') {
          if (data.length > 0) {
            console.log('Log Data = ', data);
            this.errorMsgSubscription = false
            this.displayContent = true
            this.toastr.success('Data loaded Successfully');
            this.isProgressing = false;
          } else {
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
        } else if(this.storeOptionData == 'RE-Process') {
          console.log('Re process Data = ', data[0].msg);
          this.toastr.success(data[0].msg)
          this.isProgressing = false;
        }
      });
  }

  pageEvent(e: any) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }


  FOOTFALL() {
    this.User = localStorage.getItem("Username");
    this.apiCallIdsService.getfootfall(this.User, 'BTEA', 'btea upload')
      .subscribe(
        data => {
        });
  }
}
